import React from 'react';
import { ResultBox } from 'components';
import * as Styles from 'pages/function4-result/styles';
import coinplug_logo from 'assets/coinplug-logo-horizo.png';
import config from '../../config';
import parseQueryAndVerifyAuth from '../../service/parseQueryAndVerifyAuth';

const type = config.mykeepin.authType.function4;

class function4_result extends React.Component {
    // Page state
    state = {
      statusCode: '',
      verificationResult: false,
      description: '',
    }
    // Render page
    render() {
    return (
      <Styles.PageLayout>
        <Styles.GridLayout>
          {/* 최상단 coinplug logo */}
          <Styles.LogoContainer>
            <Styles.Logo src={coinplug_logo} alt="coinplug-logo"/>
          </Styles.LogoContainer>
          {/* 상단 페이지 제목 */}
          <Styles.PageTitle>
            POPUP SAMPLE
          </Styles.PageTitle>
          <Styles.Paragraph>
            Metadium DID 기반 인증 서비스를 테스트합니다. 본 테스트는 VP를 요청하지 않는 type을 사용하기 때문에 인증한 유저에게 개인정보를 받아오지 않습니다. 인증 Code 값을 검증하면, 인증한 유저의 DID 값과 Signature 값을 받습니다.
          </Styles.Paragraph>
          {/* 결과 박스 */}
          <Styles.ResultBoxContainer>
            <Styles.ResultBoxWrapper>
              <ResultBox
                status = {this.state.verificationResult}
                status_code = { this.state.statusCode }
                description = { this.state.description }
                style={{
                  /* width: "100%", */
                  borderRadius: "16px",
                  boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 1px 0px, rgba(0, 0, 0, 0.16) 0px 3px 6px 0px"
                }}
              />
            </Styles.ResultBoxWrapper>
          </Styles.ResultBoxContainer>
        </Styles.GridLayout>
      </Styles.PageLayout>
    )
  }

  async componentDidMount() {
    await parseQueryAndVerifyAuth.call(this, type, '');
  }
};

export default function4_result;